var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveTrafficYay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a2dgBJ31A",
    d: "m109.68,83.97c5.67,0 10.28,4.6 10.28,10.28c0,25.47 0,91.6 0,117.07c0,5.68 -4.61,10.28 -10.28,10.28c-11.97,0 -37.59,0 -49.55,0c-5.68,0 -10.29,-4.6 -10.29,-10.28c0,-25.47 0,-91.6 0,-117.07c0,-5.68 4.61,-10.28 10.29,-10.28c11.96,0 37.58,0 49.55,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h1Wi95LiK",
    d: "m100.48,111.34c0,8.6 -6.98,15.58 -15.58,15.58c-8.6,0 -15.58,-6.98 -15.58,-15.58c0,-8.6 6.98,-15.58 15.58,-15.58c8.6,0 15.58,6.98 15.58,15.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d2Y9Fj7Qw",
    d: "m100.48,153.09c0,8.6 -6.98,15.58 -15.58,15.58c-8.6,0 -15.58,-6.98 -15.58,-15.58c0,-8.6 6.98,-15.58 15.58,-15.58c8.6,0 15.58,6.98 15.58,15.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c1dlrWQtME",
    d: "m100.48,194.23c0,8.6 -6.98,15.58 -15.58,15.58c-8.6,0 -15.58,-6.98 -15.58,-15.58c0,-8.6 6.98,-15.59 15.58,-15.59c8.6,0 15.58,6.99 15.58,15.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1akcxcvhm",
    d: "m57.56,125.82l-32.57,-32.56l32.57,0l0,32.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bXRsuZoq1",
    d: "m57.56,167.82l-32.57,-32.57l32.57,0l0,32.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bLuFQysvH",
    d: "m57.56,209.81l-32.57,-32.57l32.57,0l0,32.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aaee2trxFa",
    d: "m110.26,127.07l32.56,-32.56l-32.56,0l0,32.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dF8VzVCm",
    d: "m110.26,169.07l32.56,-32.57l-32.56,0l0,32.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cpOEs6U8m",
    d: "m110.26,211.06l32.56,-32.57l-32.56,0l0,32.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d4H1NGjvXz",
    d: "m129.85,69.83c-1.02,-0.32 -1.65,-0.51 -1.91,-0.59c-27.4,-8.51 -56.71,-8.64 -84.2,-0.4c-0.43,0.13 -1.53,0.46 -3.29,0.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b100zjWuC6",
    d: "m138.85,53.33c-1.23,-0.38 -1.99,-0.62 -2.3,-0.72c-33.07,-10.26 -68.46,-10.43 -101.62,-0.47c-0.53,0.15 -1.86,0.55 -3.98,1.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d3ZNaFSnnX",
    d: "m146.85,35.1c-1.07,-0.29 -1.75,-0.47 -2.01,-0.54c-38.59,-10.43 -79.24,-10.6 -117.92,-0.49c-0.53,0.13 -1.85,0.48 -3.97,1.03"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 252,
    width: 252,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_4",
    fill: "#808080",
    xlinkHref: "#a2dgBJ31A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_6",
    fill: "#ffffff",
    xlinkHref: "#h1Wi95LiK"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_8",
    fill: "#ffffff",
    xlinkHref: "#d2Y9Fj7Qw"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_10",
    fill: "#ffffff",
    xlinkHref: "#c1dlrWQtME"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_12",
    fill: "#808080",
    xlinkHref: "#a1akcxcvhm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_14",
    fill: "#808080",
    xlinkHref: "#bXRsuZoq1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_16",
    fill: "#808080",
    xlinkHref: "#bLuFQysvH"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_18",
    fill: "#808080",
    xlinkHref: "#aaee2trxFa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_20",
    fill: "#808080",
    xlinkHref: "#dF8VzVCm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_21"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_22",
    fill: "#808080",
    xlinkHref: "#cpOEs6U8m"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_24"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_25",
    strokeWidth: 5,
    stroke: "#808080",
    fillOpacity: 0,
    xlinkHref: "#d4H1NGjvXz"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_27"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_28",
    strokeWidth: 5,
    stroke: "#808080",
    fillOpacity: 0,
    xlinkHref: "#b100zjWuC6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_30"
  }, /*#__PURE__*/React.createElement("use", {
    x: 40.099995,
    y: 0.894737,
    id: "svg_31",
    strokeWidth: 5,
    stroke: "#808080",
    fillOpacity: 0,
    xlinkHref: "#d3ZNaFSnnX"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTrafficYay);
export default __webpack_public_path__ + "static/media/liveTraffic_Yay.d2df554843a3e9dec41c64d09f979df1.svg";
export { ForwardRef as ReactComponent };